


export class PublicationsDiscussingView {
    constructor() {
        this.template = document.getElementById('publication-discussing-template');
        this.container = document.getElementById('publication-discussing-container');
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        if (!this.container) { return;}
        
        state.data.forEach((publication, index) => {

            const li = this.getNextEmptyElement(this.container);
            if (li instanceof Element) { li.replaceWith(this.renderPartial(publication));}
            
        });
    }
    
    renderPartial(publication) {

        const clone = this.template.content.cloneNode(true);

        clone.querySelector('article.post').dataset.id = publication.id;
        clone.querySelector('.preview').href = publication.url;

        const img = clone.querySelector('img');
        img.src = publication.preview;
        img.dataset.src = publication.preview;
        img.alt = publication.title;

        clone.querySelector('.title a').href = publication.url;
        clone.querySelector('.title a').textContent = publication.title;
        clone.querySelector('.ci.like span').textContent = publication.counters.likes.value;
        clone.querySelector('.ci.comments span').textContent = publication.counters.comments.value;
        clone.querySelector('.ci.comments a').href = publication.url + '#comments';

        clone.querySelector('.ci.views span').textContent = publication.counters.views.value;

        if (publication.hasOwnProperty('isActiveLike') && publication.isActiveLike) { 
            clone.querySelector('.ci.like').classList.add('toggled');
        }

        return clone;
    }

    getNextEmptyElement(container) {
        return Array.from(container.querySelectorAll('.li')).find(el => {
            return !!el.querySelector('div.dummy');
        });
    }
}